// extracted by mini-css-extract-plugin
module.exports = {"link":"common_link__2GKtk"};